import React, {
  FC,
} from 'react';
import { parseUrlParams } from '../../lib/utils/utils';
import TermsOfUseContent from '../../components/TermsOfUseContent';

const WebTermsOfUse: FC = () => {
  const params = parseUrlParams<{ isEnglish: string }>(window.location.href);
  return (
    <>
      {/* 英文条款 */}
      <div style={{ width: '90%', overflow: 'auto', marginLeft: 'auto', marginRight: 'auto', textAlign: 'left' }}>
        <TermsOfUseContent />
      </div>
    </>
  );
};

export default WebTermsOfUse;
